const styleToInject = `
label + div + ._multiFieldLine_exnrn_1,
legend + div + ._multiFieldLine_exnrn_1,
label + div + ._multiFieldLine_exnrn_1 + div,
legend + div + ._multiFieldLine_exnrn_1 + div{
display: none;
}

.hidden{
display: none!Important
}

legend._textBody_2aowh_10,p._label_12thd_10._textBody_2aowh_10 {
    font-weight: 700!important;
    font-size: 16px!important;
}

`;


const intervall = setInterval(() => {
  const formEmbed = document.querySelector('shopify-forms-embed#app-embed');
  if (!formEmbed || !formEmbed.shadowRoot) return;

    // check if style already exists

    const styleEl = document.createElement('style');
    styleEl.id = 'custom-style';
    styleEl.textContent = styleToInject;
    formEmbed.shadowRoot.appendChild(styleEl);

    
  

  const shadow = formEmbed.shadowRoot;
  const explanationInput = shadow.querySelector('input[id*="explanat"]');
  const pleaseExplainInput = shadow.querySelector('input[id*="Please explain"]');

  
  if (!explanationInput || !pleaseExplainInput) return;

  // add the class to parent node of explanation input
  var parent = explanationInput.parentNode;
  if (parent && !parent.classList.contains('explanation')) {
    parent.classList.add('explanation', 'hidden');
  }

  // function to toggle visibility based on checkbox/radio state
  const toggleExplanation = () => {
    if (pleaseExplainInput.checked) {
      parent.classList.remove('hidden');
    } else {
      parent.classList.add('hidden');
    }
  };

setInterval(function(){ 
    toggleExplanation()
    }, 300);

  const explanationInput2 = shadow.querySelector('input[id*="please_specify"]');
  const pleaseExplainInput2= shadow.querySelector('input[id*="Others (Please specify)"]');


    if (!explanationInput2 || !pleaseExplainInput2) return;

  // add the class to parent node of explanation input
  var parent2 = explanationInput2.parentNode;
  if (parent2 && !parent2.classList.contains('explanationn')) {
    parent2.classList.add('explanationn', 'hidden');
  }

  // function to toggle visibility based on checkbox/radio state
  const toggleExplanation2 = () => {
    if (pleaseExplainInput2.checked) {
      parent2.classList.remove('hidden');
    } else {
      parent2.classList.add('hidden');
    }
  };

  // listen for change events
   setInterval(function(){ 
    toggleExplanation2()
    }, 300);


  const explanationInput3 = shadow.querySelector('input[id*="please_list_them_briefly"]');
  const pleaseExplainInput3= shadow.querySelector('input[id*="do_you_currently_stock_other_pet_brands-Yes"]');


    if (!explanationInput3 || !pleaseExplainInput3) return;

  // add the class to parent node of explanation input
  var parent3 = explanationInput3.parentNode;
  if (parent3 && !parent3.classList.contains('explanationnn')) {
    console.log('testing parent 3')
    parent3.classList.add('explanationnn', 'hidden');
  }

  // function to toggle visibility based on checkbox/radio state
  const toggleExplanation3 = () => {
    if (pleaseExplainInput3.checked) {
      parent3.classList.remove('hidden');
    } else {
      parent3.classList.add('hidden');
    }
  };

 setInterval(function(){ 
    toggleExplanation3()
    }, 300);

  clearInterval(intervall);
}, 300);
